import { render, staticRenderFns } from "./shopOrder.vue?vue&type=template&id=42ad073c&scoped=true"
import script from "./shopOrder.vue?vue&type=script&lang=js"
export * from "./shopOrder.vue?vue&type=script&lang=js"
import style0 from "./shopOrder.vue?vue&type=style&index=0&id=42ad073c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ad073c",
  null
  
)

export default component.exports